import { Redirect, Route, Switch } from "react-router-dom";
import { useUserAuth } from "../state/userAuthContext";
import { bulkUploadRoutes } from "./allRoutes";

const switchRoutes = (
  <Switch>
    {bulkUploadRoutes.map((prop, key) => {
      if (prop.layout === 'bulk-upload') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/bulk-upload" to="/bulk-upload/type-of-charge" />
  </Switch>
);

const BulkUpload = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default BulkUpload;